module.exports = __webpack_public_path__ + "img/92149.ae108779.svg";